import React from "react";
import { ReactTitle } from "react-meta-tags";

const styles = {
  minHeight: "100vh",
  marginTop: "2em",
  textAlign: "center",
  maxWidth: "80%",
  textAlign: "justify",
  textJustify: "inter-word",
};

const Disclaimer = () => {
  return (
    <div className="pt-1 mx-auto" style={styles}>
      <div id="disclaimer m-1"></div>
      <ReactTitle title="Vibgyor Advisors - Disclaimer" />
      <h1 className="text-center border-bottom pt-2 border-danger">
        Disclaimer
      </h1>
      <p className="lead border-bottom border-danger">
        The site, including any content or information contained within it or
        any site linked to the site, or any product or service licensed or
        purchased through the site, is provided on an "as is" basis and without
        warranties of any kind, either express or implied, including, but not
        limited to warranties of title or non-infringement or warranties of
        merchantability and fitness for a particular purpose, other than those
        warranties which are implied by and incapable of exclusion, restriction
        or modification under the laws applicable to this agreement. The website
        is owned, operated and maintained by Vibgyor Advicorp pvt
        ltd(hereinafter referred to as “Vibgyor ” or "Vibgyoradvisors.com"), a
        Company incorporated under the Companies Act, 2013 having CIN:
        U93090MH2016PTC288153 and having its Registered Office at 15,Green villa
        ,Govind nagar Ghatkopar west Mumbai-400084. <br />
        <br />
        You acknowledge that any warranty that is provided in connection with
        the products or services described herein is provided solely by the
        owner, advertiser, manufacturer or supplier of that product and/or
        service, and not by Vibgyoradvisors.com. Vibgyoradvisors.com does not
        warrant that your access to the site and/or related services will be
        uninterrupted or error-free, that defects will be corrected, or that
        this site or the server provided herein is free of viruses or other
        harmful components. Access to and use of this site and the information
        provided herein is at your own risk and Vibgyoradvisors.com does not
        undertake any accountability for any irregularities, viruses or damage
        to any computer that results from accessing, availing or downloading of
        any information from this site. Vibgyoradvisors.com does not warrant or
        make any representations regarding the use of or any consequences
        resulting from the use of any product and/or service purchased in terms
        of its compatibility, correctness, accuracy, and reliability or
        otherwise. You assume total responsibility and risk for your use of this
        site and all site-related services. <br />
        <br />
        If the foregoing limitation is held to be unenforceable, the maximum
        liability of vibgyor advisors. and its service providers to you shall
        not exceed the amount of fees paid by you for the products or services
        that you have ordered through the site. The possibility exists that the
        site could include inaccuracies or errors. Additionally, the possibility
        exists that unauthorized additions, deletions or alterations could be
        made by third parties to the site. Although Vibgyor advisors attempts to
        ensure the highest level of integrity, correctness and authenticity of
        the site, it makes no guarantees whatsoever as to its completeness,
        correctness or accuracy. In the event that any inaccuracy arises, please
        inform Vibgyor advisors so that it can be corrected. The price and value
        of investments and the income derived from them can increase or decrease
        and you may not get back the amount you invest. Changes in the rate of
        exchange may have an adverse effect on the value, price and income of
        investments in deposits other than your own. Past performance is not
        necessarily an indicator of future performance. The services and
        investments referred to in our site may have tax consequences and it is
        important to bear in mind that Vibgyor advisors does not provide tax
        advice. The level of taxation depends on individual circumstances and
        such levels and bases of taxation can change. You should consult your
        own tax advisor in order to understand any applicable tax consequences.
        <br />
        <br />
        This Internet site is only available to residents in India and is
        presently not available to foreign residents including non resident
        Indians (NRIs) in foreign jurisdictions where the services cannot be
        offered without prior regulatory compliance. In all such cases due
        efforts are being made to comply with regulatory requirements in various
        jurisdictions of which you shall be notified from time to time. This
        service does not constitute an offer to sale or a solicitation to any
        person in any jurisdiction where it is unlawful to make such an offer or
        solicitation. <br />
        <br />
        No market analysis, research report or any other information, on the web
        site is to be construed as a representation with respect to shares,
        securities or other investments. Price and availability of products and
        services offered on the site are subject to change without prior notice.
        To the extent that we provide information on the availability of
        products or services you should not rely on such information. Vibgyor
        advisors will not be liable for any lack of availability of products and
        services you may order through the site. <br />
        <br />
        Vibgyor advisorswould welcome and appreciate immediate notification or
        notice, if any person would come across any such tips, advisory,
        solicitation, opinions or related services regarding buying, selling and
        trading of any securities, directly or indirectly, in any manner from
        any person or platform which is believed to be or likely to be believed
        as Vibgyor advisors Please contact vibgyoradvisors@gmail.com for any of
        your queries with regard to the same. In no event shall Vibgyor advisors
        be liable for any investments, trades or speculative activities
        performed by any person based on any such information or content and all
        such activities shall be solely at their own risk. Transactions between
        you and Vibgyor advisors shall be governed by and construed in
        accordance with the laws of India, without regard to any conflicts of
        laws of other nations. Any litigation regarding this agreement or any
        transaction between customer and Vibgyor advisorscom or any action at
        law or in equity arising out of or relating to these agreement or
        transaction shall be filed only in the Competent Courts of Mumbai alone
        and the customer hereby agrees, consents and submits to the jurisdiction
        of such courts for the purpose of litigating any such action. <br />
        <br />
        The Stock exchange, Mumbai is not in any manner answerable, responsible
        or liable to any person pr persons for any acts of omissions or
        commission, errors, mistakes and/or partners, agents associates etc., of
        any of the Rules, regulations, bye-laws of the Stock Exchange Mumbai,
        SEBI Act or any other laws in force from time to time. The Stock
        Exchange, Mumbai is not answerable, responsible or liable for any
        information on this website or for any services rendered by us, our
        employees and our servants. Please note that any of your personal
        details; including but not limited to, your registered contact number,
        password, login information, email ID, date of birth, bank account,
        address etc., is strictly not shared with any third party ,i.e. any non
        affiliate of Vibgyor advisors, without your express consent. We vibgyor
        advisors are not liable for any profits or losses or the transfer of any
        responsibilties <br />
        <br />
        Vibgyor advisors or any of it’s affiliates, employees, agents or any
        other representatives would never contact you and ask you for your
        personal details such as your login information, password, Aadhaar OTP,
        bank account details and such other related information. Please do not
        provide any details to queries from calls where such information is
        asked by the caller who impersonates to be an affiliate of Vibgyor
        advisors For reporting any such information or for further queries with
        regard to this, please contact vibgyoradvisors@gmail.com <br />
        <br />
        The advice published by Vibgyor advisors– Investment Adviser
        (hereinafter referred to as IA) is for private circulation. Vibgyor
        advisors had applied for registration as an Investment Adviser under
        SEBI (Investment Adviser) Regulations, 2013. IA has not been debarred /
        suspended by SEBI or any other regulatory authority for accessing /
        dealing in securities Market. IA does not hold any financial interest in
        the subject company. IA may have affiliations with other intermediaries.
        IA does not have any conflict or material conflict of interest at the
        time of publication of its advice with the company covered by IA. IA has
        not received any consideration by way of remuneration or compensation or
        in any other form whatsoever, for any distribution or execution services
        in respect of the products or securities for which the investment advice
        is provided to the client. IA does not recommend the services of any
        stock broker or other intermediary to its clients. <br></br>
        IA may have investment positions in the stocks recommended in this
        advice. However, IA will always maintain a Chinese wall between his
        personal trading and advisory activities.
        <br />
        <br />
        IA has exercised due diligence in checking correctness of details and
        opinion expressed herein is unbiased. This report is meant for personal
        informational purposes and is not be construed as a solicitation or
        financial advice or an offer to buy or sell any securities or related
        financial instruments. While utmost care has been taken in preparing
        this report, we claim no responsibility for its accuracy. Recipients
        should not regard the report as a substitute for the exercise of their
        own judgment. Any opinions expressed in this report are subject to
        change without any notice and this report is not under any obligation to
        update or keep current the information contained herein. Past
        performance is not necessarily indicative of future results. The
        information in this advice has been obtained on the basis of publicly
        available information, internal data and other reliable sources believed
        to be true, but we do not represent that it is accurate or complete and
        it should not be relied on as such, as this document is for general
        guidance only. IA shall not be in any way responsible for any loss or
        damage that may arise to any person from any inadvertent error in the
        information contained in this report.
        <br />
        <br />
        Investing in Stocks and Mutual Funds involves risk. There are no
        guaranteed returns in investing. The views and investment opinion
        provided on IA are our own. We make sincere efforts to present the right
        investment perspective and thus the information contained herein is
        based on the analysis and the sources that we consider reliable.
        However, IA does not guarantee the accuracy, adequacy or completeness of
        any information and is not responsible for any errors or omissions or
        for the results obtained from the use of such information.
        <br />
        <br />
        The investments discussed or recommended on IA may not be suitable for
        all investors. Vibgyor advisors and his affiliates may hold exposure in
        term so long or short positions in the Securities/Commodities
        recommended/discussed from time to time. Vibgyor advisors and his
        affiliates may hold exposure in the Mutual Fund Schemes recommended
        <br />
        <br />
        Any action you choose to take in the markets or investing in Mutual
        Funds is totally your own responsibility. IA will not be liable for any,
        direct or indirect, consequential or incidental damages or loss arising
        out of the use of the information given in the website, through email or
        any other means of communication. IA especially states that it has no
        financial liability whatsoever to any user on account of the use of
        information provided on its website. If you don't accept this
        responsibility for yourself, then you should not use IA
        <br />
        <br />
      </p>
    </div>
  );
};

export default Disclaimer;
